/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { ICustomer } from '../../../../../store/ducks/customers/types';
import {
  Container,
  DivSearchField,
  DivWrapperMessageChooseProduct,
  DivWrapperTable
} from './styles';
import './override.css';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../routes';
import { EPurchaseRoutes } from '../../../purchase.routes';
import { EOrderSettingsRoutes } from '../orderSettings.routes';
import { removeSearchedItem } from '../../../../../store/ducks/long-steel-order-item-search/actions';
import SearchItemRadioSelect from './SearchItemRadioSelect';
import {
  ECodeType,
  IOrderEntryPreference
} from '../../../../../store/ducks/user/types';
import { Button } from '@gerdau/hefesto/Button';
import { SearchField } from '@gerdau/hefesto/SearchField';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import MessageChooseItem from '../../../../../components/MessageChooseItem';
import ProductsTable from '../ProductsTable';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { ITaggingParams } from '../../../../../store/ducks/tagging/types';
import { Toast } from '@gerdau/hefesto/Toast';
import { useCartService } from '../../../../../services/MVP/useCartService';
import {
  Hit,
  useProductForCustomer
} from '../../../../../services/MVP/useProductForCustomer';
import { SummaryBottomSearchItem } from '../../OrderSettingsMvp/SearchItem/SummaryBottomSearchItem';
import { addToast } from '../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../store/ducks/toast/types';
import LoadingModal from '../../../../../components/LoadingModal';
import { ISearchResult } from '@gerdau/hefesto/SearchField/SearchField.types';
import { cleanShoppingCart } from '../../../../../store/ducks/long-steel-shopping-cart/actions';
import { BlockedModal } from '../../../../../components/Purchase/BlockedModal';

import { v4 as uuidv4 } from 'uuid';

interface ISearchItemProps {
  emitterId: string;
  userOrderEntryPreference: IOrderEntryPreference;
  updateUserOrderEntryPreference(
    userOrderEntryPreference: IOrderEntryPreference
  ): void;
}

export interface ISearchItem {
  id: string;
  label: string;
  value?: string;
}

interface SalesAgreementData {
  salesAgreement: number;
  expirationDate: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  destination: string;
  agreementUm: string;
}

interface Price {
  creditPrice: string;
  um: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  destination: string;
  destinationDescription: string;
  isAgreementPrice: string;
  salesAgreementData: SalesAgreementData;
  quantity: string;
}

interface Product {
  id: number;
  sku: string;
  name: string;
  attribute_set_id: number;
  status: number;
  visibility: number;
  type_id: string;
  created_at: string;
  updated_at: string;
  product_links: any[];
  options: any[];
  price: Price;
}

interface ConvertedSelectedItem {
  sku: string;
  qty: number;
  quote_id: string;
  extension_attributes: {
    measure_unity_gerdau: string;
    destination_gerdau: string;
    payment_type_gerdau: string;
    has_agreed_price_gerdau: boolean;
    price_agreement_date_gerdau: string;
    sap_fields: {
      o_header_sap: any[];
      o_item_sap: any[];
      o_price_sap: any[];
    };
  };
}

const loadProductsFromLocalStorage = () => {
  try {
    const products = localStorage.getItem('selectedProducts');
    return products ? JSON.parse(products) : [];
  } catch (error) {
    console.error('Error parsing products from localStorage:', error);
    return [];
  }
};

const saveProductsToLocalStorage = (products: any) => {
  localStorage.setItem('selectedProducts', JSON.stringify(products));
};

const SearchItem: React.FC<ISearchItemProps> = ({
  emitterId,
  userOrderEntryPreference,
  updateUserOrderEntryPreference
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getCartItemQuantity, getCartId, addBulkCartItem } = useCartService();

  const {
    getProductForCustomerSKU,
    getProductForCustomerInternalCode,
    getMultProducts,
    fetchProductDetails
  } = useProductForCustomer();

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );
  const orderItemSearch = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch
  );

  const selectedCustomer = customersState.customers.find(
    (c) => c.customerId === emitterId
  );

  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const cartQuantity = useSelector(
    (state: ApplicationState) => state.cartItemsMvp.quantity
  );

  const isBlockedCustomer =
    selectedCustomer?.blocks &&
    selectedCustomer?.blocks?.filter((blc) => blc.type === 'order')?.length > 0;
  const [openBlockedModal, setOpenBlockedModal] = useState(isBlockedCustomer);
  const onCloseBlockedModal = () => {
    dispatch(cleanShoppingCart());
    setOpenBlockedModal(false);
  };
  useEffect(() => {
    setOpenBlockedModal(isBlockedCustomer);
  }, [selectedCustomer]);

  const [customer, setCustomer] = useState<ICustomer | any>();
  const [receiverId, setReceiverId] = useState('');
  const [codeType, setCodeType] = useState<ECodeType | any>();
  const [searchInputValue, setSearchInputValue] = useState<string[]>([]);
  const [initialSearchResults, setInitialSearchResults] = useState<any>([]);
  const [searchResults, setSearchResults] =
    useState<any[]>(initialSearchResults);
  const [lastActionButton] = useState('');
  const [selectedItems, setSelectedItems] = useState<any[]>(
    loadProductsFromLocalStorage()
  );
  const [showToastSuccess, setShowToastSuccess] = useState(false);
  const [showToastError, setShowToastError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showMessageNoResults, setShowMessageNoResults] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(searchResults.length);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [notFoundItems, setNotFoundItems] = useState<string[]>([]);
  const [internalCodeToSkuMap, setInternalCodeToSkuMap] = useState<{
    [key: string]: string;
  }>({});

  const customerStateLoading =
    customersState.loading ||
    !!customersState.loadingPurchaseReceivers ||
    !!customersState.loadingProductDescription ||
    !!customersState.loadingBlocks ||
    !!customersState.loadingCustomerById;

  const pageLoading = customerStateLoading || loading;

  const searchInput = React.useRef<HTMLInputElement>(null);

  const { commerceScreenName } = getTaggingInformationScreen(
    document.location.pathname
  );

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem('isReloading', 'true');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('isReloading')) {
      sessionStorage.removeItem('isReloading');
    } else {
      localStorage.removeItem('selectedProducts');
    }
  }, []);

  useEffect(() => {
    saveProductsToLocalStorage(selectedItems);
  }, [selectedItems]);

  useEffect(() => {
    setReceiverId(shoppingCartState.receiverId);
  }, [shoppingCartState.receiverId]);

  const handleTagging = (buttonLabel: string) => {
    dispatch(
      sendTagging({
        event: 'click',
        screenName: commerceScreenName,
        etapa: 'selecionar_emissor_recebedor',
        botao_navegacao: buttonLabel
      })
    );
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue: string = e.target.value || '';
    const skuArray: string[] = inputValue
      .replace(/\D+/g, ' ')
      .split(' ')
      .filter(Boolean);

    setSearchInputValue(skuArray);

    if (
      inputValue === '' ||
      inputValue.includes(' ') ||
      inputValue.endsWith(' ')
    ) {
      setShowMessageNoResults(false);
      setSearchResults(initialSearchResults);
      setSearchPerformed(false);
    } else {
      filterSearchResults(skuArray.join(' '));
    }
  };

  const sendSearchTermTagging = (term: string) => {
    if (!term) {
      return;
    }

    dispatch(
      sendTagging({
        event: 'view_search_results',
        screenName: commerceScreenName,
        etapa: 'adicione_produtos_na_lista',
        search_term: term
      })
    );
  };

  const sendAddToCartTaggingMultiProduct = (products: Product[]) => {
    if (products.length === 0) {
      return;
    }

    const value = products.map((product) => product.price?.creditPrice);

    const selectedProductsTagging: ITaggingParams = {
      event: 'add_to_cart',
      ecommerce: {
        currency: 'BRL',
        value: value.toString(),
        screenName: commerceScreenName,
        items: products.map((product) => ({
          screenName: commerceScreenName,
          item_id: product?.sku?.toString(),
          item_name: product?.name,
          etapa: 'adicione_produtos_na_lista',
          price:
            typeof product.price?.creditPrice !== 'string'
              ? ''
              : product.price?.creditPrice,
          item_list_name: 'produtos_busca',
          unidade_de_medida: product?.price?.um,
          quantity: product.price?.quantity
        }))
      }
    };
    dispatch(sendTagging(selectedProductsTagging));
  };

  const sendAddToCartTagging = (product: Product) => {
    if (!product) {
      return;
    }

    const selectedProductTagging: ITaggingParams = {
      event: 'add_to_cart',
      ecommerce: {
        currency: 'BRL',
        value: product.price?.creditPrice.toString(),
        screenName: commerceScreenName,
        items: [
          {
            screenName: commerceScreenName,
            item_id: product?.sku?.toString(),
            item_name: product.name,
            etapa: 'adicione_produtos_na_lista',
            price:
              typeof product.price?.creditPrice !== 'string'
                ? ''
                : product.price?.creditPrice,
            item_list_name: 'produtos_busca',
            unidade_de_medida: product.price?.um,
            quantity: product.price?.quantity
          }
        ]
      }
    };
    dispatch(sendTagging(selectedProductTagging));
  };

  const filterSearchResults = (inputValue: string) => {
    if (inputValue === '') {
      setSearchResults(initialSearchResults);
      setSearchPerformed(false);
    } else {
      const filteredResults = initialSearchResults.filter((result: any) =>
        result.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      setSearchResults(filteredResults);
      setShowMessageNoResults(filteredResults.length === 0);
      setSearchPerformed(true);
    }
  };

  const fetchSearchResults = async (
    inputValue: string[],
    codeType: ECodeType,
    customer: ICustomer
  ) => {
    try {
      setLoading(true);
      const codArray = inputValue
        .map((sku: string) => sku.trim())
        .filter((sku) => sku);

      let results: any;

      if (codeType === ECodeType.SKU) {
        results = await getProductForCustomerSKU(
          customer.customerId,
          customer?.division || [],
          codArray,
          [],
          codeType
        );

        const itemProduct = results.hits.hits.map((hit: Hit) => {
          const product = hit._source;
          return {
            id: product.sku,
            label: `${product.sku.toUpperCase()} - ${product.name.toUpperCase()}`
          };
        });

        if (codArray.length > 0) {
          setSearchResults((prevResults) => {
            const newResults = [...prevResults, ...itemProduct];
            return Array.from(new Set(newResults.map((a) => a.id))).map((id) =>
              newResults.find((a) => a.id === id)
            );
          });
          setInitialSearchResults((prevResults: any) => {
            const newResults = [...prevResults, ...itemProduct];
            return Array.from(new Set(newResults.map((a) => a.id))).map((id) =>
              newResults.find((a) => a.id === id)
            );
          });
        } else {
          setSearchResults(itemProduct);
          setInitialSearchResults(itemProduct);
        }
      } else {
        results = await getProductForCustomerInternalCode(
          customer.customerId,
          inputValue.map((code) => code.trim()),
          codeType,
          customer.division,
          codArray
        );

        const itemProduct = results.hits.hits.map((hit: Hit) => {
          const product = hit._source;
          return {
            id: product.internal_code,
            label: `${product.internal_code.toUpperCase()} - ${product.name.toUpperCase()}`
          };
        });

        const newMap = results.hits.hits.reduce(
          (acc: { [key: string]: string }, hit: Hit) => {
            const product = hit._source;
            acc[product.internal_code] = product.sku;
            return acc;
          },
          {}
        );

        setInternalCodeToSkuMap(newMap);

        if (codArray.length > 0) {
          setSearchResults((prevResults) => {
            const newResults = [...prevResults, ...itemProduct];
            return Array.from(new Set(newResults.map((a) => a.id))).map((id) =>
              newResults.find((a) => a.id === id)
            );
          });
          setInitialSearchResults((prevResults: any) => {
            const newResults = [...prevResults, ...itemProduct];
            return Array.from(new Set(newResults.map((a) => a.id))).map((id) =>
              newResults.find((a) => a.id === id)
            );
          });
        } else {
          setSearchResults(itemProduct);
          setInitialSearchResults(itemProduct);
        }
      }

      if (results.status !== 200) {
        showToastMessageError();
      }

      if (codArray.length === 0) {
        // setShowMessageNoResults(true);
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      setLoading(false);
      if (searchInput.current) {
        searchInput.current.focus();
      }
    }
  };

  useEffect(() => {
    if (customersState.error) {
      goToOrderSettings();

      return;
    }

    if (
      orderItemSearch.searchedItems.length > 0 &&
      !orderItemSearch.searchedItems.some((item) => !item.found) &&
      lastActionButton === 'searchAdvance'
    ) {
      handleNext();
    }
  }, [customersState.error, orderItemSearch.searchedItems, lastActionButton]);

  useEffect(() => {
    const loadCustomer = async () => {
      const codeType = selectedCustomer?.productsDescriptionResponse
        ?.customerProductsAvailable.productsAvailable
        ? userOrderEntryPreference?.codeType
        : ECodeType.SKU;
      setCodeType(codeType);
      setCustomer(selectedCustomer);

      if (
        selectedCustomer &&
        selectedCustomer?.productsDescriptionResponse &&
        !pageLoading
      ) {
        await fetchSearchResults([''], codeType, selectedCustomer);
      }
    };

    loadCustomer();
  }, [selectedCustomer]);

  const goToOrderSettings = () => {
    history.push(`${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}`);
  };

  const handleNext = async () => {
    try {
      handleTagging('avancar_para_carrinho');
      setLoading(true);
      dispatch(removeSearchedItem([]));
      const cartId = getCartId();

      const flattenedSelectedItems = selectedItems.flat();

      //Products available need has price with creditPrice > 0
      const availableItems = flattenedSelectedItems.filter(
        (item: Product) =>
          item.price &&
          Object.values(item.price).length > 0 &&
          Number(item.price?.creditPrice) > 0
      );

      const hasUnavailableItems =
        availableItems.length < flattenedSelectedItems.length;

      if (flattenedSelectedItems.length === 1 && hasUnavailableItems) {
        throw new Error();
      }

      const convertedSelectedItems = availableItems.map((item: Product) => {
        const isAgreementPrice = item.price?.isAgreementPrice;
        const salesAgreementData = item.price?.salesAgreementData;

        const prices = {
          um: isAgreementPrice
            ? salesAgreementData.agreementUm
            : item.price?.um,
          destination: isAgreementPrice
            ? salesAgreementData.destination
            : item.price?.destination,
          paymentCondition: isAgreementPrice
            ? salesAgreementData.paymentTerms
            : item.price?.paymentTerms,
          expirationDate: isAgreementPrice
            ? salesAgreementData.expirationDate
            : ''
        };

        return {
          sku: item.sku,
          qty: 1,
          quote_id: cartId,
          extension_attributes: {
            measure_unity_gerdau: prices?.um,
            destination_gerdau: prices?.destination,
            payment_type_gerdau: prices?.paymentCondition,
            has_agreed_price_gerdau: isAgreementPrice,
            price_agreement_date_gerdau: prices?.expirationDate,
            sap_fields: {
              o_header_sap: [],
              o_item_sap: [],
              o_price_sap: []
            }
          }
        };
      });

      if (cartQuantity >= 30) {
        setLoading(false);
        dispatch(
          sendTagging({
            event: 'error',
            screenName: commerceScreenName,
            mensagem: 'Seu carrinho atingiu o limite de 30 produtos.'
          })
        );
        return dispatch(
          addToast({
            type: EToastTypes.DANGER,
            message: 'Seu carrinho atingiu o limite de 30 produtos.',
            durationInMS: 3000,
            labelActionOne: 'X'
          })
        );
      }

      const cartSlice = 30 - cartQuantity;

      const itemAdded = await addBulkCartItem({
        items: convertedSelectedItems.slice(0, cartSlice) as any,
        withOptions: false,
        withPrice: false,
        noCheckPrice: cartSlice > 0
      });

      if (getCartId() && itemAdded) {
        localStorage.removeItem('selectedProducts');
        return history.push(
          `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/commerce/${EOrderSettingsRoutes.SHOPPING_CART}`
        );
      }
    } catch (error) {
      dispatch(
        sendTagging({
          event: 'error',
          screenName: commerceScreenName,
          mensagem: 'Produto indisponível.'
        })
      );
      return dispatch(
        addToast({
          type: EToastTypes.DANGER,
          message: 'Produto indisponível.',
          durationInMS: 3000,
          labelActionOne: 'X'
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const showChooseEmitterReceiver = () => {
    return (
      <>
        {openBlockedModal && (
          <BlockedModal onCloseModal={onCloseBlockedModal} />
        )}
        <MessageChooseItem message="Escolha o emissor e o recebedor para selecionar itens." />
      </>
    );
  };

  const showChooseProducts = () => {
    return (
      <MessageChooseItem message="Sua lista de produtos está vazia. Procure por produtos pelas opções acima." />
    );
  };

  const showToastMessageSuccess = () => {
    setShowToastSuccess(true);
    setTimeout(() => {
      setShowToastSuccess(false);
    }, 5000);
  };

  const showToastMessageError = () => {
    setShowToastError(true);
    setTimeout(() => {
      setShowToastError(false);
    }, 5000);
  };

  const onSelectResultOption = async (selectedItem: ISearchResult) => {
    if (loading) {
      return null;
    }

    const sku = internalCodeToSkuMap[selectedItem.id] || selectedItem.id;

    setLoading(true);

    try {
      const productItem = await fetchProductDetails(sku, emitterId, emitterId);

      const productDetails = productItem['0'];
      const productWithUUID = { ...productDetails, uniqueId: uuidv4() };

      setSelectedItems((prevSelectedItems: any) => {
        const updatedItems = [productWithUUID, ...prevSelectedItems].flat();
        saveProductsToLocalStorage(updatedItems);
        sendAddToCartTagging(productWithUUID);
        return updatedItems;
      });
      showToastMessageSuccess();
    } catch (error) {
      console.error('Error fetching search results:', error);
      showToastMessageError();
    } finally {
      setLoading(false);
      setSearchResults([]);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        // const elementos = document.querySelectorAll('.hefesto-dropdown');
        // elementos.forEach((elemento) => {
        //   (elemento as HTMLElement).style.display = 'none';
        // });

        handleAddMultipleProducts(
          currentPage,
          pageSize,
          customer.division,
          codeType
        );
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [searchInputValue, codeType]);

  useEffect(() => {
    if (pageLoading) {
      const elementos = document.querySelectorAll(
        '.hefesto-dropdown.hefesto-dropdown--bottom'
      );
      elementos.forEach((elemento) => {
        (elemento as HTMLElement).style.display = 'none';
      });
    }
  }, [pageLoading]);

  const handleAddMultipleProducts = async (
    currentPage: number,
    pageSize: number,
    codActivity: string[],
    codeType: ECodeType
  ) => {
    setShowMessageNoResults(false);
    setSearchPerformed(false);

    if ((showMessageNoResults && searchInputValue.length <= 1) || pageLoading) {
      return;
    }

    try {
      setLoading(true);
      sendSearchTermTagging(searchInputValue.join(' '));
      const trimmedInputValues = searchInputValue
        .map((value) => value.trim())
        .filter((value) => value);

      let skuArray: string[] = [];

      if (codeType === ECodeType.SKU) {
        skuArray = trimmedInputValues;
      } else {
        const results = await getProductForCustomerInternalCode(
          customer.customerId,
          trimmedInputValues,
          codeType,
          customer.division,
          []
        );

        const newMap = results.hits.hits.reduce(
          (acc: { [key: string]: string }, hit: Hit) => {
            const product = hit._source;
            acc[product.internal_code] = product.sku;
            return acc;
          },
          {}
        );

        skuArray = trimmedInputValues.map((code) => newMap[code] || code);
      }

      const productsDetails = await getMultProducts(
        skuArray,
        ECodeType.SKU,
        emitterId,
        pageSize,
        currentPage,
        codActivity
      );

      const updatedItems = [
        ...productsDetails.map((product: any) => ({
          ...product,
          uniqueId: product.uniqueId || `${product.id}-${Date.now()}`
        })),
        ...selectedItems
      ];

      setSelectedItems(updatedItems);
      saveProductsToLocalStorage(updatedItems);

      const notFound = skuArray.filter(
        (sku) => !productsDetails.some((product: any) => product.sku === sku)
      );
      setNotFoundItems(notFound);

      if (notFound.length > 0) {
        showToastMessageError();
        setShowMessageNoResults(true);
      }

      if (productsDetails.length === 0) {
        setShowMessageNoResults(true);
      }

      if (productsDetails.length > 0) {
        sendAddToCartTaggingMultiProduct(updatedItems);
      }

      setSearchResults([]);
      setLoading(false);
      setSearchPerformed(true);
    } catch (error) {
      console.error('Error fetching search results:', error);
      setLoading(false);
      setSearchPerformed(true);
    }
  };

  useEffect(() => {
    if (notFoundItems.length > 0) {
      dispatch(
        sendTagging({
          event: 'nenhum_produto_encontrado',
          screenName: commerceScreenName,
          termo_pesquisado: notFoundItems
        })
      );
    }
  }, [dispatch, notFoundItems]);

  const renderNoResultsMessage = (notFoundItems: string[]) => {
    return (
      <p
        style={{
          color: '#C74A34',
          fontSize: '16px',
          marginTop: '24px',
          marginBottom: 0
        }}
      >
        Nenhum resultado encontrado para a busca por{' '}
        <span
          style={{
            color: '#C74A34',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          {notFoundItems.join(', ')}
        </span>
        . Tente novamente com uma descrição ou código de material diferentes.
      </p>
    );
  };

  const handleUpdateSelectedItems = (updatedProducts: any[]) => {
    setSelectedItems(updatedProducts);
    saveProductsToLocalStorage(updatedProducts);
  };

  const areProductsAvailable = (products: Product[]) => {
    const availableProducts = products.filter(
      (product) => product.price?.creditPrice !== ''
    );
    return {
      hasUnavailable: availableProducts.length < products.length,
      availableProducts
    };
  };

  const { hasUnavailable } = areProductsAvailable(selectedItems);

  return (
    <>
      <Container>
        {customer && !isBlockedCustomer ? (
          <div style={{ backgroundColor: '#efefef' }}>
            <div className="search-items-content">
              <header className="search-items-content_header">
                <h3>Adicione produtos na lista</h3>
                <span className="search-items-description">
                  Crie sua lista de produtos adicionando-os pela descrição e
                  pelos códigos de material.
                </span>
              </header>

              {selectedCustomer && (
                <SearchItemRadioSelect
                  disabled={orderItemSearch.searchingItems || pageLoading}
                  codeType={userOrderEntryPreference.codeType}
                  setCodeType={(codeType: ECodeType) => {
                    if (userOrderEntryPreference.codeType === codeType) {
                      return;
                    }
                    updateUserOrderEntryPreference({
                      ...userOrderEntryPreference,
                      codeType
                    });
                  }}
                />
              )}

              <DivSearchField>
                <div style={{ width: '47.5rem' }}>
                  <SearchField
                    data-testid="hefesto-search-field"
                    label="Produtos"
                    name="search-input"
                    inputValue={searchInputValue.join(' ')}
                    onChange={handleSearchInputChange}
                    searchResultOptions={
                      searchResults.length === 0 ? undefined : searchResults
                    }
                    onSelectResultOption={onSelectResultOption}
                    placeholder="Descrição do produto ou código de material"
                    disabled={pageLoading}
                    ref={searchInput}
                    helperText="Adicione múltiplos produtos digitando os códigos de material separados por espaço."
                    optionButtonText="Adicionar produto"
                    dropdownPosition="bottom"
                  />
                </div>

                <Button
                  type="button"
                  name="Pesquisar produtos"
                  variant="primary"
                  labelPosition="center"
                  style={{ width: '16rem', height: '3rem' }}
                  onClick={() => {
                    handleAddMultipleProducts(
                      currentPage,
                      pageSize,
                      customer.division,
                      codeType
                    );
                  }}
                  disabled={!searchInputValue || pageLoading}
                >
                  Adicionar produto
                </Button>
              </DivSearchField>

              {searchPerformed &&
                notFoundItems.length > 0 &&
                renderNoResultsMessage(notFoundItems)}
            </div>
          </div>
        ) : (
          showChooseEmitterReceiver()
        )}

        {customer && !isBlockedCustomer && selectedItems.length === 0 && (
          <DivWrapperMessageChooseProduct>
            {showChooseProducts()}
          </DivWrapperMessageChooseProduct>
        )}

        {customer && !isBlockedCustomer && selectedItems.length > 0 && (
          <DivWrapperTable>
            <div>
              <ProductsTable
                codeType={codeType}
                products={selectedItems}
                saveProductsToLocalStorage={saveProductsToLocalStorage}
                handleAddMultipleProducts={handleAddMultipleProducts}
                onProductUpdate={handleUpdateSelectedItems}
              />
            </div>
          </DivWrapperTable>
        )}

        {showToastSuccess && (
          <Toast
            text="Produtos adicionados"
            showIcon={false}
            variant="success"
            onClose={() => setShowToastSuccess(false)}
          />
        )}

        {showToastError && (
          <Toast
            text="Produtos não encontrados"
            showIcon={false}
            variant="danger"
            onClose={() => setShowToastError(false)}
          />
        )}

        <LoadingModal
          enabled={pageLoading}
          title="Aguarde alguns instantes"
          message="Carregando os dados..."
        />
      </Container>

      <SummaryBottomSearchItem
        loading={pageLoading}
        handlePrevious={() => {
          handleTagging('voltar');
          history.push(`${ERoutes.PURCHASE}/commerce/steel-type-choose`);
          localStorage.removeItem('selectedProducts');
        }}
        handleNext={handleNext}
        hasProducts={
          selectedItems.length > 0 &&
          !(selectedItems.length === 1 && hasUnavailable) &&
          receiverId !== ''
        }
      />
    </>
  );
};

export default SearchItem;
